import styled from 'styled-components/macro';

const IconBlockTypeWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
  width: 60px;
  height: 60px;
  border-radius: 100px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(35, 39, 48, 0.2);
  opacity: 0.4;
  color: #282324;
`;

export default IconBlockTypeWrapper;
